import {
  PATIENT_ORDERS_ROUTE,
  PATIENT_PRODUCT_DETAIL_ROUTE,
  PATIENT_REFILL_PHARMACY_ROUTE,
  PATIENT_REFILL_ROUTE,
} from '@/routes/route-paths';
import { matchPath } from 'react-router-dom';

export const PATIENT_PORTAL_PARTNER_ROUTES = [
  PATIENT_REFILL_ROUTE,
  PATIENT_REFILL_PHARMACY_ROUTE,
  PATIENT_ORDERS_ROUTE,
  PATIENT_PRODUCT_DETAIL_ROUTE,
];

export const isPatientPortalPartnerPage = (pathname: string) =>
  Boolean(
    PATIENT_PORTAL_PARTNER_ROUTES.some((portalPartnerRoute) => matchPath({ path: portalPartnerRoute }, pathname)),
  );

export default null;
